module.exports = __webpack_public_path__ + "img/riqingyuejie.4e8fcf3d.png";